export enum ConstantsEnum {
  MAX_FILE_UPLOAD_SIZE_MB = 3,
  IMAGE_EVENT_EMPTY = 'assets/img/no_img.png',
  IMAGE_EVENT_PENDING = 'assets/img/image_pending.png',
  IMAGE_EVENT_EXPLICIT = 'assets/img/explict.svg',
  NOT_INFORMED = 'Não informado'
}
